import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=e75e1ce4&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=e75e1ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e75e1ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e75e1ce4')) {
      api.createRecord('e75e1ce4', component.options)
    } else {
      api.reload('e75e1ce4', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=e75e1ce4&scoped=true&", function () {
      api.rerender('e75e1ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25qQayxaMjk2D/JS/comp/CookieBox.vue"
export default component.exports